import React from 'react';
import { PageTitle } from '@/components/seo/page-title';
import { BusinessListPage } from '@/screens/business/business-list-page';

export default function NearbyScreen() {
  return (
    <>
      <PageTitle title="Nearby" />
      <BusinessListPage mode="nearby" title="Nearby" radiusKm={5} limit={50} />
    </>
  );
}


